import './client-module-loader.scss';

import { Spin } from 'antd';

import { AllurLoader } from '@/components/Shared/ui';
import type { IAllurLoaderProps } from '@/components/Shared/ui/allur-loader';
import { LoadingOutlined } from '@/media/antd-icons';

import { isInWebView } from '../../webview/env';

const ClientModuleLoader: React.FC<IAllurLoaderProps> = (props) => {
  const webview = isInWebView();
  if (!webview) return <AllurLoader {...props} />;

  const rootClasses = [
    'client-module-loader',
    props.fullWidth ? 'client-module-loader--full-width' : '',
    props.fullScreen ? 'client-module-loader--fullscreen' : '',
    props.blurMode ? 'client-module-loader--blur-mode' : '',
    props.layout ? 'client-module-loader--layout' : ''
  ].join(' ');

  return (
    <div className={rootClasses}>
      <Spin
        className="client-module-loader__spinner"
        indicator={<LoadingOutlined />}
        size="large"
      />
    </div>
  );
};

export default ClientModuleLoader;
